export default {
  setCollapse(state, { isCollapse }) {
    state.isCollapse = isCollapse;
  },
  setBreadcrumbItems(state, { breadcrumbItems }) {
    state.breadcrumbItems = breadcrumbItems;
  },
  setFullscreen(state, flag) {
    state.isFullscreen = flag;
  },
  setCaluploads(state, { caluploads }) {
    state.caluploads = caluploads;
  },
  deleteCalfile(state, { filename }) {
    const caluploads = [...state.caluploads];
    const deleteIndex = caluploads.findIndex(c => c.raw === filename);
    if (deleteIndex !== 1) {
      caluploads.splice(deleteIndex, 1);
      state.caluploads = caluploads;
    }
  },
  setSocket(state, socket) {
    state.socket = socket;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setVersion(state, version) {
    state.version = version;
  },
  // 设置全局时间范围
  SET_GLOBAL_PERIOD(state, period) {
    state.globalPeriod = period;
  },
};

